import BaseService from "./base";
import { keycloak } from "../keycloak/keycloak";

const apiService = new BaseService(process.env.REACT_APP_VISUALS_API_URL + '/v1/tasks', {});

export async function fetchTaskById(id) {
    if (keycloak.authenticated) {
        let headers = {
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get(`/${id}`, {}, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function searchTasks(params) {
    if (keycloak.authenticated) {
        let headers = {
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get('', params, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function createTask(boardId, data) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.post(`/board/${boardId}`, data, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function updateTask(id, data) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.patch(`/${id}`, data, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function deleteTask(id) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.delete(`/${id}`, { headers: headers });
    }
    throw new Error('You are not authenticated')
}
